import { listen, qs, qsa } from "@fluorescent/dom";

const selectors = {
  layoutToggleContainer: "[data-item-layout-toggle]",
  toggleButtons: "[data-item-layout-toggle-button]",
};

const ItemLayoutToggle = node => {
  if (!node) return;

  const layoutToggleContainerEl = qs(selectors.layoutToggleContainer, node);
  if (!layoutToggleContainerEl) return;

  const toggleButtonEls = qsa(selectors.toggleButtons, layoutToggleContainerEl);
  const clickEvent = listen(layoutToggleContainerEl, "click", _handleClick);

  function _handleClick(evt) {
    const toggleButtonEl = evt.target.closest(selectors.toggleButtons);

    if (toggleButtonEl) {
      node.setAttribute("data-item-layout", toggleButtonEl.dataset.layoutType);

      toggleButtonEls.forEach(button => {
        button.dataset.isActive = false;
      });

      toggleButtonEl.dataset.isActive = true;
    }
  }

  function unload() {
    clickEvent();
  }

  return {
    unload,
  };
};

export default ItemLayoutToggle;
